import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

// Light/dark toggle, same idea as careers.co.jp's shell/ThemeToggle.tsx:
// Sun shows while dark mode is active (click to go light), Moon while light.
// Sized to sit next to the EN/日本語 pill without outweighing it. Labels are
// English-only on purpose — the language pill's own aria-label is too, and
// the admin pages are English by design.

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const label = isDark ? "Switch to light theme" : "Switch to dark theme";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-text-2 transition-colors hover:bg-surface-2 hover:text-text"
    >
      {isDark ? (
        <Sun className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden />
      ) : (
        <Moon className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden />
      )}
    </button>
  );
}
